export default "__VITE_ASSET__VUP1roQd__"